import React from 'react';
import styles from './notfound.module.css';

const NotFound = () => {
  return (
    <div className={styles.not_found_container}>
      <img src='https://woobro.design/thumbnails/30/page-not-found-404-error-vector-illustration-5de1881dd11bc.png' />
      <h1>404! Page not Found</h1>
    </div>
  );
};

export default NotFound;
